<template>
  <div>
    <div id="body">
      <div class="wrapper">
        <div class="usercenter">
          <UserLeftGuid :menuActive="'/user/vip'"></UserLeftGuid>

          <div class="main">
            <div class="title">
              <h2>
                <svg
                  t="1653550410309"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2364"
                  width="64"
                  height="64"
                >
                  <path
                    d="M561.71026963 133.50290015a77.6722963 77.6722963 0 0 1 9.96794429 9.96794429L719.12612386 320.40833539l162.64578845-120.10726042a77.6722963 77.6722963 0 0 1 121.50536177 81.29700386L848.57995022 900.36148148H175.42004978L20.72272592 281.62396918a77.6722963 77.6722963 0 0 1 121.50536177-81.32289421L304.87387614 320.40833539l147.44790994-176.93749095a77.6722963 77.6722963 0 0 1 109.41437391-9.96794429zM512 193.18111406l-194.33608533 233.22401542-221.57317098-163.62963793L236.05622162 822.68918518h551.88755676l139.96547793-559.91369363-221.57317098 163.62963793L512 193.18111406z m181.23535762 486.22857483v82.85044978H330.76464238v-82.85044978h362.47071524z"
                    p-id="2365"
                  ></path>
                </svg>
                我的VIP
              </h2>
            </div>
            <div class="box">
              <div class="box-content" v-loading="loading">
                <div class="intro">
                  <img
                    class="avatar"
                    src="@/assets/images/user-pic.png"
                    alt=""
                  />
                  {{ $store.state.userInfo.username }}
                  <!-- ，请选择<strong>VIP</strong>会员服务 -->
                </div>
                <el-tabs
                  class="vip-tabs"
                  v-model="activeName"
                  type="card"
                  @tab-click="handleTabClick"
                >
                  <el-tab-pane name="1">
                    <span slot="label">
                      <svg
                        t="1647333798619"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="25224"
                        width="18"
                        height="18"
                      >
                        <path
                          d="M512.027591 967.111111a155.875556 155.875556 0 0 1-116.906667-52.935111L39.224036 509.838222a157.866667 157.866667 0 0 1-12.401778-192.170666L174.648036 97.564444A155.619556 155.619556 0 0 1 303.984924 28.444444H719.95648c51.911111 0 100.266667 25.827556 129.336889 69.12l147.939555 220.103112a157.866667 157.866667 0 0 1-12.401777 192.170666L628.962702 914.204444A155.875556 155.875556 0 0 1 512.027591 967.111111z m0-206.364444a123.960889 123.960889 0 0 0 92.814222-41.984l255.288889-290.104889a42.666667 42.666667 0 0 0-3.697778-60.017778 42.040889 42.040889 0 0 0-59.648 3.697778l-255.288888 290.076444a38.684444 38.684444 0 0 1-29.468445 13.340445 38.684444 38.684444 0 0 1-29.468444-13.368889L227.270258 372.337778a42.040889 42.040889 0 0 0-59.676445-3.697778 42.666667 42.666667 0 0 0-3.669333 60.046222l255.288889 290.104889A123.960889 123.960889 0 0 0 512.027591 760.746667z"
                          p-id="25225"
                        ></path>
                      </svg>
                      VIP会员
                    </span>
                    <div class="adv" v-if="countDown">
                      <div class="text">{{ countDown }}</div>
                      <img src="@/assets/images/user-adv.png" alt="" />
                    </div>
                    <div
                      v-if="!payOk"
                      class="pay"
                      style="margin-top: 20px"
                      v-loading="loading"
                    >
                      <div class="type-select">
                        <el-radio-group
                          v-model="vipType"
                          @change="handleChange"
                          size="small"
                        >
                          <template v-for="(item, index) in tableData">
                            <template v-if="item.name == 'VIP年卡'">
                              <el-radio
                                class="y"
                                :label="item.id"
                                border
                                :key="index"
                              >
                                <span class="price">
                                  {{ item.executionPrice }}
                                  <small>
                                    (<del> {{ item.price }} </del>)
                                  </small>
                                  <sub> 元/<span>年</span> </sub>
                                </span>
                                <span class="name">
                                  <img
                                    src="~@/assets/images/icon-vip-1.png"
                                    alt=""
                                  />
                                  钻石年卡
                                </span>
                              </el-radio>
                            </template>

                            <template v-if="item.name == 'VIP季卡'">
                              <el-radio
                                class="s"
                                :label="item.id"
                                border
                                :key="index"
                              >
                                <span class="price">
                                  {{ item.executionPrice }}
                                  <small>
                                    (
                                    <del>
                                      {{ item.price }}
                                    </del>
                                    )
                                  </small>
                                  <sub> 元/<span>季</span> </sub>
                                </span>
                                <span class="name">
                                  <img
                                    src="~@/assets/images/icon-vip-2.png"
                                    alt=""
                                  />
                                  钻石季卡
                                </span>
                              </el-radio>
                            </template>

                            <template v-if="item.name == 'VIP月卡'">
                              <el-radio
                                class="m"
                                :label="item.id"
                                border
                                :key="index"
                              >
                                <span class="price">
                                  {{ item.executionPrice }}
                                  <small>
                                    (
                                    <del>{{ item.price }}</del>
                                    )
                                  </small>
                                  <sub> 元/<span>月</span> </sub>
                                </span>
                                <span class="name">
                                  <img
                                    src="~@/assets/images/icon-vip-3.png"
                                    alt=""
                                  />
                                  钻石月卡
                                </span>
                              </el-radio>
                            </template>
                          </template>
                        </el-radio-group>
                      </div>

                      <div class="border">
                        <div class="amount">
                          应付金额：
                          <strong>{{ item.executionPrice }}</strong>
                          元
                        </div>
                        <div class="pay-select">
                          <el-radio-group v-model="payType">
                            <el-radio :label="0">
                              <img
                                src="~@/assets/images/pay-wechat.png"
                                alt=""
                              />
                            </el-radio>
                            <el-radio :label="1">
                              <img src="~@/assets/images/pay-ali.png" alt="" />
                            </el-radio>
                          </el-radio-group>
                        </div>
                        <div class="submit">
                          <el-button
                            @click="handlePayOk()"
                            type="primary"
                            round
                          >
                            确认开通
                          </el-button>
                        </div>
                        <div class="tip">
                          <a
                            href="javascript:void(0);"
                            style="color: red"
                            @click="handlerAgreement"
                          >
                            支付即同意《VIP服务协议》
                          </a>
                        </div>
                      </div>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane name="2">
                    <span slot="label">
                      <svg
                        t="1647333798619"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="25224"
                        width="18"
                        height="18"
                      >
                        <path
                          d="M512.027591 967.111111a155.875556 155.875556 0 0 1-116.906667-52.935111L39.224036 509.838222a157.866667 157.866667 0 0 1-12.401778-192.170666L174.648036 97.564444A155.619556 155.619556 0 0 1 303.984924 28.444444H719.95648c51.911111 0 100.266667 25.827556 129.336889 69.12l147.939555 220.103112a157.866667 157.866667 0 0 1-12.401777 192.170666L628.962702 914.204444A155.875556 155.875556 0 0 1 512.027591 967.111111z m0-206.364444a123.960889 123.960889 0 0 0 92.814222-41.984l255.288889-290.104889a42.666667 42.666667 0 0 0-3.697778-60.017778 42.040889 42.040889 0 0 0-59.648 3.697778l-255.288888 290.076444a38.684444 38.684444 0 0 1-29.468445 13.340445 38.684444 38.684444 0 0 1-29.468444-13.368889L227.270258 372.337778a42.040889 42.040889 0 0 0-59.676445-3.697778 42.666667 42.666667 0 0 0-3.669333 60.046222l255.288889 290.104889A123.960889 123.960889 0 0 0 512.027591 760.746667z"
                          p-id="25225"
                        ></path>
                      </svg>
                      SVIP会员
                    </span>
                    <div class="adv" v-if="countDown">
                      <div class="text">{{ countDown }}</div>
                      <img src="@/assets/images/user-adv.png" alt="" />
                    </div>
                    <div
                      v-if="!payOk"
                      class="pay"
                      style="margin-top: 20px"
                      v-loading="loading"
                    >
                      <div class="type-select">
                        <el-radio-group
                          v-model="vipType"
                          @change="handleChange"
                          size="small"
                        >
                          <template v-for="(item, index) in tableData">
                            <template v-if="item.name == 'SVIP年卡'">
                              <el-radio
                                class="y"
                                :label="item.id"
                                border
                                :key="index"
                              >
                                <span class="price">
                                  {{ item.executionPrice }}
                                  <small>
                                    (<del> {{ item.price }} </del>)
                                  </small>
                                  <sub> 元/<span>年</span> </sub>
                                </span>
                                <span class="name">
                                  <img
                                    src="~@/assets/images/icon-vip-1.png"
                                    alt=""
                                  />
                                  钻石年卡
                                </span>
                              </el-radio>
                            </template>

                            <template v-if="item.name == 'SVIP季卡'">
                              <el-radio
                                class="s"
                                :label="item.id"
                                border
                                :key="index"
                              >
                                <span class="price">
                                  {{ item.executionPrice }}
                                  <small>
                                    (
                                    <del>
                                      {{ item.price }}
                                    </del>
                                    )
                                  </small>
                                  <sub> 元/<span>季</span> </sub>
                                </span>
                                <span class="name">
                                  <img
                                    src="~@/assets/images/icon-vip-2.png"
                                    alt=""
                                  />
                                  钻石季卡
                                </span>
                              </el-radio>
                            </template>

                            <template v-if="item.name == 'SVIP月卡'">
                              <el-radio
                                class="m"
                                :label="item.id"
                                border
                                :key="index"
                              >
                                <span class="price">
                                  {{ item.executionPrice }}
                                  <small>
                                    (
                                    <del>{{ item.price }}</del>
                                    )
                                  </small>
                                  <sub> 元/<span>月</span> </sub>
                                </span>
                                <span class="name">
                                  <img
                                    src="~@/assets/images/icon-vip-3.png"
                                    alt=""
                                  />
                                  钻石月卡
                                </span>
                              </el-radio>
                            </template>
                          </template>
                        </el-radio-group>
                      </div>

                      <div class="border">
                        <div class="amount">
                          应付金额：
                          <strong>{{ item.executionPrice }}</strong>
                          元
                        </div>
                        <div class="pay-select">
                          <el-radio-group v-model="payType">
                            <el-radio :label="0">
                              <img
                                src="~@/assets/images/pay-wechat.png"
                                alt=""
                              />
                            </el-radio>
                            <el-radio :label="1">
                              <img src="~@/assets/images/pay-ali.png" alt="" />
                            </el-radio>
                          </el-radio-group>
                        </div>
                        <div class="submit">
                          <el-button
                            @click="handlePayOk()"
                            type="primary"
                            round
                          >
                            确认开通
                          </el-button>
                        </div>
                        <div class="tip">
                          <a
                            href="javascript:void(0);"
                            style="color: red"
                            @click="handlerAgreement"
                          >
                            支付即同意《VIP服务协议》
                          </a>
                        </div>
                      </div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :title="agreement.title" :visible.sync="showAgreement">
      <span v-html="agreement.content"></span>
    </el-dialog>
  </div>
</template>

<script>
import UserLeftGuid from "../../components/user/left_guid.vue";
import { axiosRequest, axiosOptions } from "../../util/request";
import moment from "moment";

export default {
  components: { UserLeftGuid },
  data() {
    return {
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      pageCount: 0,
      total: 0,
      loading: false,
      activeName: "1",
      countDown: 0,
      payOk: false,
      vipType: 0,
      item: {},
      payType: 0,
      code: "",
      agreement: {},
      showAgreement: false,
    };
  },
  created() {
    this.getAgreement(5);
    this.getMemberTypeList();
  },
  mounted() {},
  methods: {
    handleTabClick(tab) {
      if (tab.name === "1") {
        this.item = this.tableData.find((i) => i.name === "VIP年卡");
      } else if (tab.name === "2") {
        this.item = this.tableData.find((i) => i.name === "SVIP年卡");
      }
      this.vipType = this.item.id;
    },
    getAgreement(id) {
      axiosRequest(
        "/agreement/details",
        { id: id },
        axiosOptions("post", "", "json")
      ).then((res) => {
        if (res.data.code === 200) {
          this.agreement = res.data.data;
        }
      });
    },
    getMemberTypeList() {
      this.loading = true;
      axiosRequest("/vip/member-type-list", {}, axiosOptions("get", "", "post"))
        .then((res) => {
          this.loading = false;
          if (res.data.code === 200) {
            this.tableData = res.data.data;
            if (this.tableData && this.tableData.length > 0) {
              this.item = this.tableData[0];
              this.vipType = this.item.id;
            }
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    dateFormat(cellValue, type) {
      if (!cellValue) return "";
      if (type === "date") {
        return moment(cellValue).format("YYYY-MM-DD");
      }
      return moment(cellValue).format("YYYY-MM-DD HH:mm:ss");
    },
    handleChange(val) {
      this.item = this.tableData.find((i) => i.id === val);
    },
    handlerAgreement() {
      this.showAgreement = true;
    },
    submitForm() {},
    handlerExAgreement() {},
    handlePayOk() {
      if (this.payType === 0) {
        this.$router.push({
          path: "/user/wechatpay",
          query: {
            MemberTypeId: this.item.id,
            PayMoney: this.item.executionPrice,
          },
        });
      } else if (this.payType === 1) {
        axiosRequest(
          "/vip/ali-pay",
          { id: this.item.id },
          axiosOptions("post", "", "json")
        ).then((res) => {
          if (res.data.code === 200) {
            const div = document.createElement("div");
            div.innerHTML = res.data.data;
            document.body.appendChild(div);
            document.forms[0].submit();
          } else {
            this.$message.error("提交失败，请稍后重试！");
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/var.scss";
@import "~@/assets/css/usercenter.scss";
.intro {
  height: 90px;
  margin-bottom: 15px;
  padding: 20px;
  font-size: $fontSizeSmall;
  font-weight: bold;
  line-height: 30px;
  color: #fff;
  background-color: $colorMain;
  border-radius: 5px 5px 0 0;
  .avatar {
    width: 30px;
    height: 30px;
    margin-right: 10px;
    border-radius: 30px;
    vertical-align: -10px;
  }
  strong {
    margin: 0 5px;
    color: #ffc001;
  }
}
.vip-tabs {
  //   margin-top: -65px;
  margin-top: -40px;
  ::v-deep {
    .el-tabs__header {
      border: 0;
    }
    .el-tabs__nav-wrap {
      margin-bottom: 0;
    }
    .el-tabs__nav {
      width: 100%;
      border: 0;
    }
    .el-tabs__item {
      width: 50%;
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      text-align: center;
      background-color: #ebebeb;
      border: 0;

      &.is-active {
        background-color: #fff;
        z-index: 1;
      }
      &:first-child {
        width: calc(50% - 20px);
        margin-right: 20px;
        border-radius: 10px 25px 0 0;
        &.is-active {
          &:after {
            border-left-color: #fff;
            border-bottom-color: #fff;
          }
        }
        &:after {
          position: absolute;
          bottom: 0;
          border-width: 24px 40px;
          border-style: solid;
          border-color: transparent;
          content: "";
          right: -65px;
          border-left-color: #ebebeb;
          border-bottom-color: #ebebeb;
        }
      }
      &:last-child {
        width: calc(50% - 20px);
        margin-left: 20px;
        border-radius: 25px 10px 0 0;
        &.is-active {
          &:before {
            border-right-color: #fff;
            border-bottom-color: #fff;
          }
        }
        &:before {
          position: absolute;
          bottom: 0;
          border-width: 24px 40px;
          border-style: solid;
          border-color: transparent;
          content: "";
          left: -65px;
          border-right-color: #ebebeb;
          border-bottom-color: #ebebeb;
        }
      }
      .el-badge {
        vertical-align: top;
      }
      .el-badge__content.is-fixed {
        top: 12px;
      }
      svg {
        font-size: 1.2em;
        margin-right: 5px;
        vertical-align: -4px;
      }
    }
  }
}
.adv {
  position: relative;
  margin-bottom: 50px;
  img {
    width: 100%;
  }
  .text {
    position: absolute;
    right: 80px;
    top: 28px;
    font-size: 30px;
    font-weight: bold;
    color: #ff1e00;
  }
}
.type-select {
  margin-bottom: 35px;
  text-align: center;
  .el-radio {
    width: 245px;
    height: 160px;
    padding: 25px;
    border: 1px solid #e5e5e5;
    vertical-align: top;
    @media screen and (max-width: 768px) {
      width: 167%;
      margin: 0 0 15px !important;
      transform: scale(0.6);
      transform-origin: 0 0;
      + .el-radio {
        margin-top: -60px !important;
      }
    }
    &.is-checked {
      border: 2px solid #ff5a00;
      box-shadow: 0 5px 10px rgba(255, 90, 0, 0.2);
      ::v-deep {
        .el-radio__label {
          &:before {
            position: absolute;
            right: 3px;
            bottom: 2px;
            width: 13px;
            height: 13px;
            font-family: element-icons !important;
            font-size: 16px;
            color: #fff;
            z-index: 1;
            content: "";
          }
          &:after {
            position: absolute;
            right: 0;
            bottom: 0;
            border-width: 13px;
            border-style: solid;
            border-color: transparent #ff5a00 #ff5a00 transparent;
            content: "";
          }
        }
      }
    }
    &.y {
      &:before {
        position: absolute;
        left: -2px;
        top: -13px;
        width: 48px;
        height: 27px;
        background: url(~@/assets/images/pay-type-sp1.png) no-repeat;
        content: "";
      }
      &:after {
        position: absolute;
        right: 17px;
        top: 0px;
        width: 34px;
        height: 34px;
        background: url(~@/assets/images/pay-type-sp2.png) no-repeat;
        content: "";
      }
    }
    &.s {
      ::v-deep {
        .el-radio__label {
          > span.name {
            color: #e8a203;
          }
        }
      }
    }
    &.m {
      ::v-deep {
        .el-radio__label {
          > span.name {
            color: #666666;
          }
        }
      }
    }
    ::v-deep {
      .el-radio__input {
        display: none;
      }
      .el-radio__label {
        display: block;

        > span {
          display: block;
          &.price {
            height: 60px;
            margin-bottom: 10px;
            font-size: 36px;
            font-weight: bold;
            color: #ff3f15;
            line-height: 54px;
            border-bottom: 1px dashed #c8c9cc;
            small {
              font-size: 18px;
              font-weight: normal;
              color: #333333;
              vertical-align: 2px;
              del {
                vertical-align: -2px;
              }
            }
            sub {
              font-size: 14px;
              font-weight: normal;
              color: #333333;
              vertical-align: 1px;
              span {
                color: #ff3f15;
              }
            }
          }
          &.name {
            font-size: 16px;
            line-height: 30px;
            color: #f70f36;
            img {
              margin-right: 5px;
              vertical-align: -2px;
            }
          }
        }
      }
    }
  }
}
.border {
  padding: 25px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 5px;

  .submit {
    margin: 40px 0 0;
    border: 0;
    .el-button {
      width: 184px;
      height: 45px;
      font-size: 18px;
      background-color: #68bf7b !important;
      border-color: #68bf7b !important;
      border-radius: 50px;
      @media screen and (max-width: 768px) {
        width: 100%;
        height: 40px;
        font-size: 16px;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  * + .border {
    margin-top: -90px;
  }
}

.amount {
  margin-bottom: 40px;
  font-size: 16px;
  color: #262626;
  strong {
    font-size: 24px;
    color: #ff3900;
  }
}
.pay-select {
  .el-radio {
    img {
      vertical-align: middle;
    }
    @media screen and (max-width: 768px) {
      width: 100%;
      margin-right: 0;
      + .el-radio {
        margin-top: 20px;
      }
    }
  }
  ::v-deep {
    .el-radio__input.is-checked {
      .el-radio__inner:after {
        background-color: #68bf7b;
      }
    }
    .el-radio__inner {
      width: 22px;
      height: 22px;
      background-color: #fff;
      border-color: #68bf7b;
      &:after {
        width: 10px;
        height: 10px;
      }
    }
  }
}
.exchange {
  padding: 50px 80px;
  @media screen and (max-width: 768px) {
    padding: 0;
  }
  .name {
    font-size: 24px;
    margin-bottom: 30px;
  }
  .input {
    text-align: center;
    .el-input {
      width: 365px;
      @media screen and (max-width: 768px) {
        width: 100%;
        margin-bottom: 15px;
      }
    }
    .el-button {
      margin-left: 10px;
      width: 100px;
    }
  }
}
.tip {
  margin-top: 60px;
  text-align: left;
}
.pay-ok {
  padding: 20px;
  text-align: center;
  line-height: 50px;
  img {
    margin-bottom: 30px;
    margin-right: -33px;
  }
  h4 {
    font-size: 30px;
    font-weight: bold;
  }
  p {
    font-size: 18px;
    strong {
      color: #ff0000;
    }
  }
}
</style>
